import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    standalone: false
})
export class NavigationComponent {

    @Output()
    toggleSidebar = new EventEmitter<void>();

    public showSearch = false;

    constructor(
        private authService: AuthService,
        private router: Router
    ) {

    }

    logout() {
        this.authService.doLogout();
    }
}
